/* "Pit lane" mobile navigation (snippets/mobile-nav.liquid). header.js opens and closes the
   dialog (hamburger, search icon, close button, backdrop); this file runs the panel stack:
   drill in/out with focus moved to the new panel's title and back to the row that opened it,
   Escape steps back one level before it closes the sheet, the stack resets when the sheet
   closes, Cart hands over to the cart drawer, and in-sheet links close the sheet. */
(function () {
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hydrated = new WeakSet();

  // The sheet's markup sits in <template data-mnav-template> until the menu or search button is first touched, focused, hovered
  // or clicked (capture phase, so it is in place before header.js calls showModal). Desktop visitors never pay for it.
  function hydrate() {
    const nav = document.querySelector('[data-mnav]');
    if (!nav || hydrated.has(nav)) return;
    const tpl = nav.querySelector('template[data-mnav-template]');
    if (tpl) { nav.appendChild(tpl.content.cloneNode(true)); tpl.remove(); }
    hydrated.add(nav);
    setup(nav);
  }
  ['pointerdown', 'touchstart', 'focusin', 'mouseover', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target.closest && e.target.closest('[data-hamburger], [data-search-toggle]')) hydrate();
    }, { capture: true, passive: true });
  });
  window.KabutoMobileNav = { hydrate: hydrate };

  function setup(nav) {
  const panels = Array.from(nav.querySelectorAll('[data-mnav-panel]'));
  const root = nav.querySelector('[data-mnav-panel="root"]');
  const stack = []; // [{ panel, opener }]
  const hamburger = document.querySelector('[data-hamburger]');

  function current() {
    return stack.length ? stack[stack.length - 1].panel : root;
  }

  function show(next, prev, direction) {
    next.hidden = false;
    next.inert = false;
    next.classList.remove('is-left', 'is-right');
    next.classList.add(direction === 'forward' ? 'is-right' : 'is-left');
    // Force the start position, then slide in.
    void next.offsetWidth;
    next.classList.add('is-current');
    next.classList.remove('is-right', 'is-left');

    prev.classList.remove('is-current');
    prev.classList.add(direction === 'forward' ? 'is-left' : 'is-right');
    prev.inert = true;
    const done = function () {
      prev.hidden = true;
      prev.classList.remove('is-left', 'is-right');
    };
    if (reduce) done();
    else setTimeout(done, 420);
  }

  function open(id, opener) {
    const panel = nav.querySelector('[data-mnav-panel="' + id + '"]');
    if (!panel) return;
    const prev = current();
    stack.push({ panel: panel, opener: opener });
    if (opener) opener.setAttribute('aria-expanded', 'true');
    show(panel, prev, 'forward');
    panel.querySelectorAll('[data-mnav-tabpanel] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    const title = panel.querySelector('.mnav__panel-title');
    const scroller = panel.querySelector('.mnav__scroll');
    if (scroller) scroller.scrollTop = 0;
    if (title) title.focus({ preventScroll: true });
  }

  function back() {
    if (!stack.length) return false;
    const leaving = stack.pop();
    const target = current();
    if (leaving.opener) leaving.opener.setAttribute('aria-expanded', 'false');
    show(target, leaving.panel, 'back');
    if (leaving.opener) leaving.opener.focus({ preventScroll: true });
    return true;
  }

  function reset() {
    while (stack.length) {
      const item = stack.pop();
      if (item.opener) item.opener.setAttribute('aria-expanded', 'false');
    }
    panels.forEach(function (p) {
      const isRoot = p === root;
      p.hidden = !isRoot;
      p.inert = !isRoot;
      p.classList.toggle('is-current', isRoot);
      p.classList.remove('is-left', 'is-right');
    });
    const scroller = root.querySelector('.mnav__scroll');
    if (scroller) scroller.scrollTop = 0;
  }

  // Feature panels (Riders): ARIA tabs. Click or arrows select a championship; the photos of every tab start
  // loading as soon as the panel opens, so switching is instant.
  function selectTab(tab, focus) {
    const list = tab.closest('[data-mnav-tabs]');
    list.querySelectorAll('[data-mnav-tab]').forEach(function (t) {
      const on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      const pane = document.getElementById(t.getAttribute('aria-controls'));
      if (pane) pane.hidden = !on;
    });
    if (focus) tab.focus();
  }

  nav.addEventListener('keydown', function (e) {
    const tab = e.target.closest && e.target.closest('[data-mnav-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
    const tabs = Array.from(tab.closest('[data-mnav-tabs]').querySelectorAll('[data-mnav-tab]'));
    let i = tabs.indexOf(tab);
    if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
    else if (e.key === 'Home') i = 0;
    else i = tabs.length - 1;
    e.preventDefault();
    selectTab(tabs[i], true);
  });

  nav.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { nav.close(); return; }
    const tabBtn = e.target.closest('[data-mnav-tab]');
    if (tabBtn) { selectTab(tabBtn, false); return; }
    const opener = e.target.closest('[data-mnav-open]');
    if (opener) { open(opener.getAttribute('data-mnav-open'), opener); return; }
    if (e.target.closest('[data-mnav-back]')) { back(); return; }
    if (e.target.closest('[data-mnav-cart]')) {
      nav.close();
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      return;
    }
    const link = e.target.closest('[data-mnav-link]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      // Same-page links (#…) would otherwise leave the sheet open.
      setTimeout(function () { if (nav.open) nav.close(); }, 0);
    }
  });

  // Escape: step back one panel first; close only from the top level. Handled on keydown
  // because Chrome only lets a dialog's "cancel" be prevented after a recent user tap.
  nav.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && stack.length) { e.preventDefault(); e.stopPropagation(); back(); }
  });
  nav.addEventListener('cancel', function (e) {
    if (stack.length) { e.preventDefault(); back(); }
  });

  nav.addEventListener('close', function () {
    reset();
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  });

  // Sync the cart count from the header badge each time the sheet opens.
  const count = nav.querySelector('[data-mnav-cart-count]');
  const syncCount = function () {
    const badge = document.querySelector('.header__cart-count');
    if (!count || !badge) return;
    const n = parseInt(badge.textContent, 10) || 0;
    count.textContent = n;
    count.hidden = badge.hidden || n === 0;
  };
  new MutationObserver(function () { if (nav.open) syncCount(); }).observe(nav, { attributes: true, attributeFilter: ['open'] });

  // The theme toggles inside the sheet were not in the page when mips-mark.js synced the labels.
  const light = document.documentElement.getAttribute('data-theme') === 'light';
  nav.querySelectorAll('[data-color-toggle]').forEach(function (b) {
    b.setAttribute('aria-pressed', light ? 'true' : 'false');
    b.setAttribute('aria-label', light ? 'Switch to dark theme' : 'Switch to light theme');
  });

  reset();
  }
})();
